import { mapState } from 'vuex'

export const FocusReporterMixin = {
  data() {
    return {
      el: null,
      mouseDownTriggered: false
    }
  },
  computed: {
    ...mapState('field', ['name'])
  },
  mounted() {
    const el = this.$refs.input

    el.addEventListener('mousedown', this.onMouseDown)
    el.addEventListener('focus', this.onFocus)
    el.addEventListener('blur', this.onBlur)
  },
  methods: {
    onMouseDown(evt) {
      this.mouseDownTriggered = true
    },
    onFocus(evt) {
      this.focusReportEvent(evt, { mouse: this.mouseDownTriggered })
    },
    onBlur(evt) {
      this.mouseDownTriggered = false // reset until next focus
      this.blurReportEvent(evt)
    },
    blurReportEvent(evt) {
      if (this.needsHelp) this.helpedBlurReport(evt)
      this.blurReport(evt)
    },
    focusReportEvent(evt, metadata = {}) {
      if (!this.isDisabled) {
        if (this.needsHelp) this.helpedFocusReport(evt)
        this.focusReport(evt, metadata)
      }
    }
  }
}
